const fromStoreResultToStore = (storeResultData) => {
  const {
    code,
    globalStoreId,
    name,
    shortName,
    streetName,
    streetNumber,
    additionalStreetInfo,
    postalCode,
    town,
    province,
    country,
    lat,
    lon,
    phone,
    slug,
    distance,
    wheelchairAccessible,
    hearingAppointmentPossible,
    isFranchiseStore
  } = storeResultData;
  return {
    code,
    globalStoreId,
    name,
    shortName,
    streetName,
    town,
    country,
    phone,
    streetNumber,
    additionalStreetInfo,
    postalCode,
    province,
    lat,
    lon,
    emailAddress: void 0,
    appointmentTypes: [],
    slug: slug ?? void 0,
    distance: distance ?? void 0,
    wheelchairAccessible,
    hearingAppointmentPossible,
    isFranchise: isFranchiseStore
  };
};
export {
  fromStoreResultToStore
};
//# sourceMappingURL=from-store-result-to-store.js.map
